<template>
    <div id="app">
    <!-- <el-row>
      <el-autocomplete v-model="state4" :fetch-suggestions="querySearchAsync" placeholder="请输入内容" @select="handleSelect"></el-autocomplete>
    </el-row> -->
    <!-- <el-row type="flex" class="row-bg" justify="center">
      <el-col :span="20">

        <router-view/>
      </el-col>
    </el-row> -->
    <div style="background-color:#f8f9fa">
      <div class="container">
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col :span="4">
            <a data-ix="logo" class="logo-link w-nav-brand w--current"><img src="https://paine.blob.core.chinacloudapi.cn/common/logo-p-800.png" width="150" class="logo"></a>
          </el-col>

          <el-col :span="6">
            <nav role="navigation" class="nav-menu w-nav-menu" style="transform: translateY(0px) translateX(0px);">
              <!-- <a  class="nav-link">主頁</a>
              <a class="nav-link" href="#">產品</a> -->
               <router-link class="nav-link" to="/">主頁</router-link>
                <!-- <router-link class="nav-link" to="/products">產品</router-link> -->
              <i class="nav-link el-icon-search" v-if="!showSearch" @click="showSearch=true" style="line-height:20px;"></i>
              <el-autocomplete v-if="showSearch" class="autocomplete" v-model="searchStr" :fetch-suggestions="querySearchAsync" placeholder="型号搜索" @select="handleSelect">
                <template slot-scope="{ item }">

                  <el-row type="flex">
                    <el-col>
                      <img class="searchimg" :src="encodeURI(item.image.replace('paine.blob.core.chinacloudapi.cn', 'cdn.jimeizone.com') + '?basic=50h_70q.webp')" />
                    </el-col>
                    <el-col class="searchresult">
                      <p>{{ item.number }}</p>
                      <p class="name">{{item.name}}</p>
                    </el-col>
                  </el-row>

                </template>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                <i slot="suffix" class="el-input__icon el-icon-close" @click="showSearch=false"></i>
              </el-autocomplete>
              <div class="audioBox">
                <img v-if="isPlaying" src="https://paine.blob.core.chinacloudapi.cn/gscasa/Sound.svg" width="18" height="18" @click="stop" />
                <img v-else src="https://paine.blob.core.chinacloudapi.cn/gscasa/NoSound.svg" width="14" height="14" @click="play" />
              </div>

            </nav>

            <!-- <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" active-text-color="#EC2F48">
            <el-menu-item index="1">
              <a class="nav_link" href="http://www.gscasa.com">主頁</a>
            </el-menu-item>
            <el-menu-item index="2">產品</el-menu-item>
          </el-menu> -->
          </el-col>

        </el-row>

      </div>

    </div>

    <keep-alive exclude="Detail">
      <router-view/>
    </keep-alive>
    <audio id="audio" autoplay="autoplay" loop="loop" preload="auto" src="https://paine.blob.core.chinacloudapi.cn/gscasa/bg.m4a">
      你的浏览器不支持audio标签
    </audio>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue';
import axios from "axios";
let lastKey = "";
let lastResult = [];
export default {
  name: 'app',
  data: function() {
    return {
      activeIndex: "2",
      searchStr: "",
      showSearch: false,
      isPlaying: false
    };
  },
  methods: {
    querySearchAsync(queryString, cb) {
      let that = this;
      if (queryString != undefined && queryString.length > 0) {
        if (queryString != lastKey) {
          let url = `http://gs.chinacloudsites.cn/api/Search?searchStr=${queryString.toUpperCase()}`;
            axios.get(url)
            .then(function(response) {
              cb(response.data);
              lastResult = response.data;
              lastKey = queryString;
              console.log(lastResult);
            })
            .catch(function(error) {
              console.log(error);
            });
        } else {
          cb(lastResult);
        }
      } else {
        cb([]);
      }
    },

    handleSelect(item) {
      console.log(this.$route.fullPath);
      this.showSearch = false;
      this.$router.push({
        name: "Detail",
        params: { number: item.number, image: item.image }
      });
    },
    play() {
      var audio = document.querySelector("#audio");
      if (!this.isPlaying) {
        audio.play();
        this.isPlaying = true;
      }
    },
    stop() {
      var audio = document.querySelector("#audio");
      if (this.isPlaying) {
        audio.pause();
        this.isPlaying = false;
      }
    }
  }
}
</script>

<style>
body {
  margin: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.nav_link {
  text-decoration: none;
}
.audioBox {
  display: flex; /*Flex布局*/
  display: -webkit-flex; /* Safari */
  align-items: center; /*指定垂直居中*/
   min-width: 30px;
   padding: 28px 20px 27px;
}
.logo {
  margin: 18px;
}
.searchimg {
  background-color: #f5f7fa;

  line-height: 50px;
}
.searchresult {
  color: gray;
  height: 60px;
  line-height: 10px;
  overflow: hidden;
  font-size: 13px;
}
.searchresult > .name {
  font-size: 10px;
}

.nav-menu {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.nav-link {
  padding: 28px 20px 27px;
  -webkit-transition: color 150ms ease;
  transition: all 150ms ease;
  color: #111;
  font-size: 14px;
  min-width: 30px;
}
.nav-link:hover {
  color: #ec2f48;
}
.autocomplete {
  padding: 17.5px 20px;
  min-width: 180px;
  transition: all 0.5s;
}
a {
  text-decoration: none;
}
.el-carousel__mask,
.el-cascader-menu,
.el-cascader-menu__item.is-disabled:hover,
.el-collapse-item__header,
.el-collapse-item__wrap {
  background-color: transparent;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}
@media (min-width: 1300px) {
  .container {
    max-width: 1100px;
  }
}
@media (min-width: 1600px) {
  .container {
    max-width: 1400px;
  }
}
.container-fluid {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.center {
  display: block;
  margin-right: auto;
  margin-left: auto;
}
.el-menu--horizontal {
  border-bottom: 0;
}
</style>
